module.exports = __webpack_public_path__ + "media/src/assets/images/case-det-74fa60615ae998558151d9f2ac3f6dfa.jpg";